import { useEffect, useState } from 'react'
import { Grid, Layout, theme } from 'antd'
import { useTranslation } from 'react-i18next'
import { Outlet, useLocation } from 'react-router-dom'
import { AppHeader } from './AppHeader'
import { AppSider } from './AppSider'
import { MobileNavDrawer } from './MobileNavDrawer'
import { findNavItem } from './navItems'

const COLLAPSE_KEY = 'xsib.sidebarCollapsed'

function readCollapsed(): boolean {
  try {
    return localStorage.getItem(COLLAPSE_KEY) === '1'
  } catch {
    return false
  }
}

export function AppLayout() {
  const { t } = useTranslation()
  const location = useLocation()
  const { token } = theme.useToken()
  const screens = Grid.useBreakpoint()
  const [collapsed, setCollapsed] = useState(readCollapsed)
  const [mobileNavOpen, setMobileNavOpen] = useState(false)

  // `md` dan tor ekranda (telefon, kichik planshet) doimiy ustun ekranning
  // yarmini yeb qo'yardi — o'rniga suzuvchi panel (`MobileNavDrawer`)
  // ishlatiladi, `AppHeader`dagi tugma esa uni yig'ish o'rniga ochadi.
  const isMobile = screens.md === false

  useEffect(() => {
    try {
      localStorage.setItem(COLLAPSE_KEY, collapsed ? '1' : '0')
    } catch {
      // e'tiborsiz
    }
  }, [collapsed])

  // Sahifa almashganda mobil panel avtomatik yopiladi — `Menu.onClick`
  // ichida ham yopiladi, lekin havola brauzer orqasiga qaytish kabi
  // Menu'dan tashqari yo'l bilan o'zgarsa ham SHU YERDA kafolatlanadi.
  useEffect(() => {
    setMobileNavOpen(false)
  }, [location.pathname])

  // Sarlavha marshrutdan olinadi — har sahifada qo'lda yozilsa, biri
  // unutiladi va header bo'sh qoladi. Moslashtirish mantiqi `navItems` da va
  // sidebar bilan BIR XIL: ikki nusxa bo'lsa, sarlavha bilan yonib turgan
  // menyu elementi bir-biriga mos kelmay qolardi
  const active = findNavItem(location.pathname)

  return (
    <Layout style={{ minHeight: '100vh' }}>
      {isMobile ? (
        <MobileNavDrawer open={mobileNavOpen} onClose={() => setMobileNavOpen(false)} />
      ) : (
        <AppSider collapsed={collapsed} />
      )}
      <Layout>
        <AppHeader
          title={active ? t(active.labelKey) : t('app.name')}
          collapsed={collapsed}
          onToggleCollapsed={() => setCollapsed((v) => !v)}
          {...(isMobile ? { onOpenMobileNav: () => setMobileNavOpen(true) } : {})}
        />
        <Layout.Content
          className="xsib-content"
          style={{ padding: 24, background: token.colorBgLayout, overflowX: 'hidden' }}
        >
          {/* Kenglik chegarasi: keng monitorda jadval ustunlari cho'zilib
              ketsa, ko'z bir qatorni oxirigacha kuzata olmaydi */}
          <div style={{ maxWidth: 1600, margin: '0 auto', width: '100%' }}>
            <Outlet />
          </div>
        </Layout.Content>
      </Layout>
    </Layout>
  )
}
